import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { SupplierDto, SupplierSearchRequest, UpsertSupplierDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/suppliers`;

export const searchSuppliers = (searchCriteria: Partial<SupplierSearchRequest>, source: CancelTokenSource):
    Promise<Array<SupplierDto>> => {

  return axios
      .post(`${apiUri}/search`, searchCriteria,{cancelToken: source.token})
      .then(response => response.data);
}

export const getAllSuppliers = (
    source: CancelTokenSource): Promise<Array<SupplierDto>> => {

  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
}

export const getSupplier = (supplierId: number, source: CancelTokenSource): Promise<UpsertSupplierDto> => {

  return axios
      .get(`${apiUri}/${supplierId}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const addSupplier = (upsertSupplierDto: UpsertSupplierDto, source: CancelTokenSource): Promise<SupplierDto> => {

  return axios
      .post(apiUri, upsertSupplierDto, {cancelToken: source.token})
      .then(response => response.data);
}

export const editSupplier = (supplierId: number, upsertSupplierDto: UpsertSupplierDto, source: CancelTokenSource):
    Promise<SupplierDto> => {

  return axios
      .put(`${apiUri}/${supplierId}`, upsertSupplierDto, {cancelToken: source.token})
      .then(response => response.data)
}

export const deleteSupplier = (supplierId: number, source: CancelTokenSource): Promise<SupplierDto> => {

  return axios
      .delete(`${apiUri}/${supplierId}`, {cancelToken: source.token})
      .then(response => response.data)
}
